export const GET_TAXES_TO_PAY_SUCCESS = 'GET_TAXES_TO_PAY_SUCCESS';
export const GET_TAXES_TO_PAY_FAIL = 'GET_TAXES_TO_PAY_FAIL';
export const SET_TAXES_TO_PAY_LIST = 'SET_TAXES_TO_PAY_LIST';
export const PAY_TAXES_BY_SZ_CARD_SUCCESS = 'PAY_TAXES_BY_SZ_CARD_SUCCESS';
export const PAY_TAXES_BY_SZ_CARD_FAIL = 'PAY_TAXES_BY_SZ_CARD_FAIL';
